import { fetchDelete, fetchGet, fetchPost, fetchPut } from './fetch';

interface UserInfoResponse {
  data: UserInfoDto;
}

export interface UserInfoDto {
  expires_at: number;
  id: string;
  name: string;
  role: string;
  credit: any;
  email: string;
  profile_image?: string;
  permissions: any[];
  plan: {
    key: string;
    name: string;
  };
}

export const bootstrap = async (): Promise<UserInfoDto> => {
  const url = `/api/auth/info`;
  return fetchGet<UserInfoDto>(url);
};
